<template>
	<div>
		<v-alert
			v-if="$store.state.connections.invitationcodes.createdInvitationcode"
			color="secondary"
			dark
			icon="fas fa-envelope-open-text"
			border="right"
		>
			<h4>Here's your invitation:</h4>Below, you will find the generated invitation code, along with a text snippet you can copy-paste into an email for the supplier.
			<v-card light class="pa-3 mt-3" style="font-size: 1em; white-space: pre;">{{invSnippet}}</v-card>
			<v-container class="pt-3 pl-0">
				<v-btn v-if="!isAuditNewPage" color="orangeButton" @click="copyInvSnippet">Copy snippet to Clipboard</v-btn>
				<!-- <v-btn light class="ml-3" @click="copyInvSnippet">Copy Snippet to Clipboard</v-btn> -->
			</v-container>
		</v-alert>
		<v-snackbar v-model="snackbar" bottom color="primary" timeout="8000">
			{{snackbarText}}
			<template v-slot:action="{ attrs }">
				<v-btn dark text v-bind="attrs" @click="snackbar = false">Close</v-btn>
			</template>
		</v-snackbar>
	</div>
</template>

<script>
export default {
	data() {
		return {
			snackbarText: "",
			snackbar: false,
		}
	},
	mounted() {
		this.$store.dispatch(
			"connections/invitationcodes/setCreatedInvitationCode",
			{
				invitationcode: null,
			}
		)
	},
	methods: {
		copyToClipboard(text, snackbarText) {
			navigator.clipboard
				.writeText(text)
				.then(() => {
					this.snackbarText = snackbarText
					this.snackbar = true
				})
				.catch(() => {
					this.snackbarText = "Could not copy to clipboard!"
					this.snackbar = true
				})
		},
		// The function is never called because clients were confused, when only code was copied. 
		copyInvCode() {
			this.copyToClipboard(
				this.$store.state.connections.invitationcodes
					.createdInvitationcode,
				"Invitation Code was successfully copied to clipboard!"
			)
		},
		copyInvSnippet() {
			this.copyToClipboard(
				this.invSnippet,
				"Invitation Code snippet was successfully copied to clipboard!"
			)
		},
	},
	computed: {
		isAuditNewPage() {
			return this.$route.path === "/audit/auditor/new"
		},
		isNisRequestPage() {
			return this.$route.path === "/nis/request"
		},
		invSnippet() {
			const code = this.$store.state.connections.invitationcodes
				.createdInvitationcode
			const link = `https://${location.host}/invite?code=${code}`
			if (this.isNisRequestPage) {
				return `Welcome to Orixe!
You have been invited to complete the Orixe NIS Cyber Security Self-Assessment.

Here's your invite code: ${code}

You can also click the link below, or copy-paste it into your browser:
${link}

After you register and log in, open the invitation notification to fill out the NIS survey.`
			}
			return `Welcome to Orixe!
Here's your invite code: ${code}

You can also click the link below, or copy-paste it into your browser:
${link}`
		},
	},
}
</script>

<style>
</style>